import { createContext, useContext, useState } from "react";
import axios from "axios";
import { useAuthContext } from "./AuthContext";
import { useFetchContext } from "./FetchContext";
import { toast } from "react-toastify";
import { useAdminContext } from "./AdminContext";
import { baseUrl } from "../data/constant";
import { useNavigate } from "react-router-dom";

const INITIAL_STATES = {
  isLoading: null,
  response: null,
  errorResponse: null,
  isError: null,
  errorMessage: "",
};

export const PostContext = createContext(INITIAL_STATES);

export const PostContextProvider = ({ children }) => {
  const [postState, setPostState] = useState(INITIAL_STATES);
  const { token, isAdmin } = useAuthContext();
  const { fetchPackages, fetchClasses, fetchCategories } = useFetchContext();

  const PostPackage = async (formData) => {
    setPostState({ ...postState, isLoading: true });
    try {
      const { data } = await axios.post(`${baseUrl}/package/create`, formData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (data.success) {
        console.log("🚀 ~ PostPackage ~ data:", data);
        setPostState({
          ...postState,
          response: data.message,
        });
        toast.success("Package Added");
        fetchPackages();
      }
    } catch (error) {
      setPostState({ ...postState, isError: true });
      toast.error("Something Went Wrong");
    } finally {
      setPostState({
        ...postState,
        isLoading: false,
      });
    }
  };
  const DeletePackage = async (id) => {
    setPostState({ ...postState, isLoading: true });
    try {
      const { data } = await axios.delete(`${baseUrl}/package/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (data.success) {
        setPostState({
          ...postState,
          response: data.message,
        });
        toast.success("Package Deleted");
        fetchPackages();
      }
    } catch (error) {
      setPostState({ ...postState, isError: true });
      toast.error("Something Went Wrong");
    } finally {
      setPostState({
        ...postState,
        isLoading: false,
      });
    }
  };
  const EditPackage = async (id, formData) => {
    setPostState({ ...postState, isLoading: true });
    try {
      const { data } = await axios.put(`${baseUrl}/package/${id}`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (data.success) {
        setPostState({
          ...postState,
          response: data.message,
        });
        toast.success("Package Updated");
        fetchPackages();
      }
    } catch (error) {
      setPostState({ ...postState, isError: true });
      toast.error("Something Went Wrong");
    } finally {
      setPostState({
        ...postState,
        isLoading: false,
      });
    }
  };
  const PostClass = async (formData) => {
    setPostState({ ...postState, isLoading: true });
    try {
      const { data } = await axios.post(`${baseUrl}/class/create`, formData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (data.success) {
        console.log("🚀 ~ PostClass ~ data:", data);
        setPostState({
          ...postState,
          response: data.message,
        });
        toast.success("Class Added");
        fetchClasses();
      }
    } catch (error) {
      setPostState({ ...postState, isError: true });
      toast.error("Something Went Wrong");
    } finally {
      setPostState({
        ...postState,
        isLoading: false,
      });
    }
  };
  const EditClassData = async (id, formData) => {
    setPostState({ ...postState, isLoading: true });
    try {
      const { data } = await axios.put(`${baseUrl}/class/${id}`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (data.success) {
        setPostState({
          ...postState,
          response: data.message,
        });
        toast.success("Class Updated");
        fetchClasses();
      }
    } catch (error) {
      setPostState({ ...postState, isError: true });
      toast.error("Something Went Wrong");
    } finally {
      setPostState({
        ...postState,
        isLoading: false,
      });
    }
  };
  const DeleteClass = async (id) => {
    setPostState({ ...postState, isLoading: true });
    try {
      const { data } = await axios.delete(`${baseUrl}/class/${id}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (data.success) {
        console.log("🚀 ~ DeleteClass ~ data:", data);
        setPostState({
          ...postState,
          response: data.message,
        });
        toast.success("Class Deleted");
        fetchClasses();
      }
    } catch (error) {
      setPostState({ ...postState, isError: true });
      toast.error("Something Went Wrong");
    } finally {
      setPostState({
        ...postState,
        isLoading: false,
      });
    }
  };
  const PostCategory = async (formData) => {
    setPostState({ ...postState, isLoading: true });
    try {
      const { data } = await axios.post(`${baseUrl}/category/`, formData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (data.success) {
        console.log("🚀 ~ PostCategory ~ data:", data);
        setPostState({
          ...postState,
          response: data.message,
        });
        fetchCategories();
        return data;
      }
    } catch (error) {
      setPostState({ ...postState, isError: true });
      toast.error("Something Went Wrong");
    } finally {
      setPostState({
        ...postState,
        isLoading: false,
      });
    }
  };
  const UpdateCategory = async (formData, id) => {
    setPostState({ ...postState, isLoading: true });
    try {
      const { data } = await axios.put(`${baseUrl}/category/${id}`, formData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (data.success) {
        console.log("🚀 ~ UpdateCategory ~ data:", data);
        setPostState({
          ...postState,
          response: data.message,
        });
        toast.success("Category Updated");
        fetchCategories();
      }
    } catch (error) {
      setPostState({ ...postState, isError: true });
      toast.error("Failed To Update Category");
    } finally {
      setPostState({
        ...postState,
        isLoading: false,
      });
    }
  };
  const DeleteCategory = async (id) => {
    setPostState({ ...postState, isLoading: true });
    try {
      const { data } = await axios.delete(`${baseUrl}/category/${id}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (data.success) {
        console.log("🚀 ~ DeleteCategory ~ data:", data);
        setPostState({
          ...postState,
          response: data.message,
        });
        toast.success("Catgory Deleted");
        fetchCategories();
      }
    } catch (error) {
      setPostState({ ...postState, isError: true });
      toast.error("Something Went Wrong");
    } finally {
      setPostState({
        ...postState,
        isLoading: false,
      });
    }
  };
  const ReturnAppointmentPayment = async (formData) => {
    setPostState({ ...postState, isLoading: true });
    try {
      const { data } = await axios.post(
        `${baseUrl}/admin/refund-payment`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (data.success) {
        toast.success("Amount Refunded");
      }
    } catch (error) {
      setPostState({ ...postState, isError: true });
      toast.error("Refund Failed");
    } finally {
      setPostState({
        ...postState,
        isLoading: false,
      });
    }
  };
  const UpdateProfile = async (formData) => {
    setPostState({ ...postState, isLoading: true, isError: null });
    try {
      const { data } = await axios.put(
        `${baseUrl}/user/update-profile`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (data.success) {
        toast.success("Updated");
        setPostState({
          ...postState,
          response: data.message,
        });
        loadUser();
      }
    } catch (error) {
      setPostState({ ...postState, isError: true });
      toast.error("Something went wrong, Try again in a moment");
    } finally {
      setPostState({
        ...postState,
        isLoading: false,
      });
    }
  };
  const UpdatePassword = async (formData) => {
    setPostState({ ...postState, isLoading: true, isError: null });
    try {
      const { data } = await axios.put(
        `${baseUrl}/user/change-password`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (data.success) {
        toast.success("Password Updated");
        setPostState({
          ...postState,
          response: data.message,
        });
        loadUser();
      }
    } catch (error) {
      setPostState({ ...postState, isError: true });
      toast.error(error.response.data.data.error);
    } finally {
      setPostState({
        ...postState,
        isLoading: false,
      });
    }
  };
  const AddPhoneNumber = async (formData) => {
    setPostState({ ...postState, isLoading: true, isError: null });
    try {
      const { data } = await axios.post(
        `${baseUrl}/user/add-phone-number`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (data.success) {
        toast.success("Phone Number Added");
        setPostState({
          ...postState,
          response: data.message,
        });
        loadUser();
      }
    } catch (error) {
      setPostState({ ...postState, isError: true });
      toast.error("Something went wrong, Try again in a moment");
    } finally {
      setPostState({
        ...postState,
        isLoading: false,
      });
    }
  };
  const UpdatePhoneNumber = async (formData) => {
    setPostState({ ...postState, isLoading: true, isError: null });
    try {
      const { data } = await axios.put(
        `${baseUrl}/user/update-phone-number`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (data.success) {
        toast.success("Phone Number Updated");
        setPostState({
          ...postState,
          response: data.message,
        });
        loadUser();
      }
    } catch (error) {
      setPostState({ ...postState, isError: true });
      toast.error("Something went wrong, Try again in a moment");
    } finally {
      setPostState({
        ...postState,
        isLoading: false,
      });
    }
  };
  const AddAvatar = async (formData) => {
    setPostState({ ...postState, isLoading: true, isError: null });
    try {
      const { data } = await axios.post(
        `${baseUrl}/user/add-avatar`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (data.success) {
        toast.success("Profile Picture Added");
        setPostState({
          ...postState,
          response: data.message,
        });
        loadUser();
      }
    } catch (error) {
      setPostState({ ...postState, isError: true });
      toast.error("Something went wrong, Try again in a moment");
    } finally {
      setPostState({
        ...postState,
        isLoading: false,
      });
    }
  };
  const UpdateAvatar = async (formData) => {
    setPostState({ ...postState, isLoading: true, isError: null });
    try {
      const { data } = await axios.put(
        `${baseUrl}/user/update-avatar`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (data.success) {
        toast.success("Profile Picture Changed");
        setPostState({
          ...postState,
          response: data.message,
        });
        loadUser();
      }
    } catch (error) {
      setPostState({ ...postState, isError: true });
      toast.error("Something went wrong, Try again in a moment");
    } finally {
      setPostState({
        ...postState,
        isLoading: false,
      });
    }
  };
  const DisableDay = async (formData) => {
    setPostState({ ...postState, isLoading: true });
    try {
      const { data } = await axios.post(
        `${baseUrl}/disabled/disable-date`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (data.success) {
        toast.success(data?.message || "Day Disabled Succesfully");
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.data?.error ||
          "Something went wrong, Try again in a moment"
      );
    } finally {
      setPostState({
        ...postState,
        isLoading: false,
      });
    }
  };
  const updateKyc = async (formData) => {
    setPostState({ ...postState, isLoading: true });
    try {
      const { data } = await axios.put(
        `${baseUrl}/admin/provider-status-update`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (data.success) {
        toast.success(data?.message || "Appointment Accepted");
        return data;
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.data?.error ||
          "Something went wrong, Try again in a moment"
      );
    } finally {
      setPostState({
        ...postState,
        isLoading: false,
      });
    }
  };

  const updateCmsSection = async (formData) => {
    setPostState({ ...postState, isLoading: true });
    try {
      const { data } = await axios.put(
        `${baseUrl}/admin/update-section-preferences`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (data.success) {
        toast.success(data?.message || "Sections Updated");
        return data;
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.data?.error ||
          "Something went wrong, Try again in a moment"
      );
    } finally {
      setPostState({
        ...postState,
        isLoading: false,
      });
    }
  };

  const updateFeaturedService = async (serviceId, formData) => {
    setPostState({ ...postState, isLoading: true });
    try {
      const { data } = await axios.put(
        `${baseUrl}/service/update-featured-services/${serviceId}`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (data.success) {
        toast.success(data?.message || "Sections Updated");
        return data;
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.data?.error ||
          "Something went wrong, Try again in a moment"
      );
    } finally {
      setPostState({
        ...postState,
        isLoading: false,
      });
    }
  };

  const toggleProviderRestriction = async (newState, id) => {
    try {
      const apiUrl = newState
        ? `${baseUrl}/admin/providers/${id}/restrict`
        : `${baseUrl}/admin/providers/${id}/unrestrict`;

      const { data } = await axios.put(
        apiUrl,
        { state: newState },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (data.success) {
        toast.success(
          data.message ||
            `Provider ${newState ? "restricted" : "unrestricted"} successfully`
        );
        return data;
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Failed to toggle provider status"
      );
      throw error;
    }
  };

  const toggleUserRestriction = async (newState, id) => {
    try {
      const apiUrl = newState
        ? `${baseUrl}/admin/providers/${id}/restrict`
        : `${baseUrl}/admin/providers/${id}/unrestrict`;

      const { data } = await axios.put(
        apiUrl,
        { state: newState },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (data.success) {
        toast.success(
          data.message ||
            `Provider ${newState ? "restricted" : "unrestricted"} successfully`
        );
        return data;
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Failed to toggle provider status"
      );
      throw error;
    }
  };

  return (
    <PostContext.Provider
      value={{
        ...postState,
        PostPackage,
        DeletePackage,
        EditPackage,
        PostClass,
        EditClassData,
        DeleteClass,
        PostCategory,
        UpdateCategory,
        DeleteCategory,
        UpdateProfile,
        UpdatePassword,
        ReturnAppointmentPayment,
        AddPhoneNumber,
        UpdatePhoneNumber,
        AddAvatar,
        UpdateAvatar,
        DisableDay,
        updateKyc,
        updateCmsSection,
        updateFeaturedService,
        toggleProviderRestriction,
        toggleUserRestriction,
      }}
    >
      {children}
    </PostContext.Provider>
  );
};

export const usePostContext = () => useContext(PostContext);
